import { SVGProps, Ref, forwardRef } from 'react'
const SvgCheck = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path fill="#fff" d="M4 5h16v15H4z" />
    <path
      fill="currentColor"
      d="M12 0a12 12 0 1 0 12 12A12.014 12.014 0 0 0 12 0Zm6.171 10.114-6.816 6.813a1.715 1.715 0 0 1-2.425 0L5.829 13.83a1.717 1.717 0 0 1 2.43-2.424l1.886 1.886 5.596-5.601a1.716 1.716 0 1 1 2.43 2.422Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCheck)
export default ForwardRef
